<template>
    <div>
        <progressable-button
            type="button"
            class="py-2 px-4 rounded-md hidden md:inline-block"
            :loading="syncing"
            state="..."
            @click.native="sync"
            v-if="this.is_active"
        >
            <font-awesome-icon
                :icon="['fas', 'shipping-fast']"
            ></font-awesome-icon>
            Deliver Now
        </progressable-button>
        <progressable-button
            type="button"
            class="py-2 px-4 rounded-md"
            :class="
                this.is_active
                    ? 'bg-destructive shadow-destructive'
                    : 'bg-primary'
            "
            :loading="loading"
            :state="loadingState"
            @click.native="toggle"
        >
            <font-awesome-icon
                :icon="['far', 'stop-circle']"
                v-if="this.is_active"
            ></font-awesome-icon>
            {{ cta }}
        </progressable-button>
        <progressable-button
            type="button"
            class="py-2 px-4 rounded-md md:hidden"
            :loading="syncing"
            state="..."
            @click.native="sync"
            v-if="this.is_active"
        >
            <font-awesome-icon
                :icon="['fas', 'shipping-fast']"
            ></font-awesome-icon>
            Deliver Now
        </progressable-button>
    </div>
</template>

<style lang="scss">
.status {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background: #2eca8b;
}
</style>

<script>
import ActivateSummaryModal from "./ActivateSummaryModal.vue";

export default {
    data() {
        return {
            user: undefined,
            loading: false,
            syncing: false,
            loadingState: "...",
        };
    },
    mounted() {
        this.loading = true;

        axios
            .get("/api/me")
            .then((response) => {
                this.user = response.data.data;
            })
            .catch((err) => {
                console.error(err);
            })
            .then(() => {
                this.loading = false;
            });
    },
    computed: {
        is_active() {
            return this.user && this.user.mailbox.is_active;
        },
        cta() {
            return this.is_active ? "Stop Mailman" : "Activate Mailman";
        },
    },
    methods: {
        toggle() {
            return this.is_active ? this.deactivate() : this.activate();
        },
        deactivate() {
            this.loadingState = "Stopping...";
            this.loading = true;

            axios
                .post("/api/stop")
                .then((response) => {
                    this.user.mailbox.is_active = false;
                    Event.$emit("mailbox:deactivated");
                })
                .catch((err) => {
                    console.log(err);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        activate() {
            if (!this.user.permissions.use_feature_daily_digest) {
                // No point asking for the choice when they don't have the choice.
                return this.activateWithoutConfirming();
            }

            if (!this.user.mailbox.confirm_when_activating)
                return this.activateWithoutConfirming();

            Modal.show(ActivateSummaryModal, {
                propsData: {
                    mailbox: this.user.mailbox,
                },
            })
                .then((response) => {
                    this.activateWithoutConfirming();
                    const isFilteringSpam = response.daily_digest;
                    const confirmWhenActivating = !response.remember;
                    axios
                        .put("/api/mailbox", {
                            is_filtering_spam: isFilteringSpam,
                            confirm_when_activating: confirmWhenActivating,
                        })
                        .then((response) => {
                            this.user.mailbox.is_filtering_spam =
                                isFilteringSpam;
                            this.user.mailbox.confirm_when_activating =
                                confirmWhenActivating;
                        })
                        .catch(console.error);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        activateWithoutConfirming() {
            this.loadingState = "Activating...";
            this.loading = true;

            axios
                .post("/api/start", {
                    utc_offset: new Date().getTimezoneOffset(),
                })
                .then((response) => {
                    this.user.mailbox.is_active = true;
                    Event.$emit("mailbox:activated");
                })
                .catch((err) => {
                    if (
                        err.response.status === 403 &&
                        err.response?.data?.message
                    ) {
                        Event.$emit("toast", {
                            text: err.response.data?.message,
                            type: "danger",
                        });
                    }
                    console.log(err);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        sync() {
            this.syncing = true;

            axios
                .post("/api/deliveries")
                .then((response) => {
                    Event.$emit("toast", {
                        text: "Success! Collected mails should be in your inbox anytime now.",
                    });
                })
                .catch((err) => {
                    console.log(err);
                    if (
                        err.response.status === 403 &&
                        err.response?.data?.message
                    ) {
                        Event.$emit("toast", {
                            text: err.response.data?.message,
                            type: "danger",
                        });
                    }
                })
                .then(() => {
                    this.syncing = false;
                });
        },
    },
};
</script>
